'use strict';

const ContinueButtonPresenter = require('../presenters/continueButton');

const BaseView = require('./base');

class ContinueButtonView extends BaseView {
  initialize() {
    this.setModule('glive_booking_redesign');
    this.presenter = ContinueButtonPresenter;
    this.templateName = 'continueButton';
  }

  attributes() {
    return { isTouch: this.model ? this.model.get('isTouch') : undefined };
  }

  _disableButton() {
    $(this.el)
      .find('button.disabled')
      .click(e => e.preventDefault());
  }
}

module.exports = ContinueButtonView;
